import React from "react";
import { Users, Building2, Check } from "lucide-react";
import Cta from "@/components/ui-kit/Cta";
import { Reveal } from "@/components/motion/Reveal";

const CONTRACTOR_POINTS = [
  "Automatic set aside on every deposit",
  "A live view of what is routed and what stays",
  "Reports ready at quarter and year end",
];

const AGENCY_POINTS = [
  "Every client's set asides in one dashboard",
  "Earn 0.25% on every routed transaction",
  "CSV and PDF reports, client data isolated",
];

export default function DualAudience({ location = "dual-audience" }) {
  return (
    <div className="grid gap-6 lg:grid-cols-2">
      <Reveal className="group flex flex-col rounded-3xl border border-etap-deep-100 bg-white p-8 shadow-etap-md transition-shadow duration-300 hover:shadow-etap-lg sm:p-10">
        <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-etap-primary-50 text-etap-primary">
          <Users className="h-6 w-6" aria-hidden="true" />
        </span>
        <h3 className="mt-6 font-display text-2xl font-bold tracking-tight text-etap-deep-800">For Contractors</h3>
        <p className="mt-3 text-etap-deep-600">
          Never scramble at quarterly deadlines again. Set your percentage once, then get paid and stay current.
        </p>
        <ul className="mt-6 space-y-3">
          {CONTRACTOR_POINTS.map((p) => (
            <li key={p} className="flex items-start gap-3 text-sm text-etap-deep-700">
              <Check className="mt-0.5 h-5 w-5 shrink-0 text-etap-primary" aria-hidden="true" />
              {p}
            </li>
          ))}
        </ul>
        <div className="mt-8 flex flex-wrap gap-3">
          <Cta to="/get-started" variant="primary" location={`${location}-contractor`} withArrow testId="dual-contractor-cta">
            Start Free Setup
          </Cta>
          <Cta to="/contractors" variant="ghost" location={`${location}-contractor-learn`} testId="dual-contractor-learn">
            Learn more
          </Cta>
        </div>
      </Reveal>

      <Reveal
        delay={0.1}
        className="group flex flex-col rounded-3xl border border-etap-mint-300 bg-etap-mint-100 p-8 shadow-etap-md transition-shadow duration-300 hover:shadow-etap-lg sm:p-10"
      >
        <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-etap-deep text-white">
          <Building2 className="h-6 w-6" aria-hidden="true" />
        </span>
        <h3 className="mt-6 font-display text-2xl font-bold tracking-tight text-etap-deep-800">
          For Agencies and Accountants
        </h3>
        <p className="mt-3 text-etap-deep-700">
          Manage set asides for every client in one place, and earn 0.25% on every routed transaction.
        </p>
        <ul className="mt-6 space-y-3">
          {AGENCY_POINTS.map((p) => (
            <li key={p} className="flex items-start gap-3 text-sm text-etap-deep-800">
              <Check className="mt-0.5 h-5 w-5 shrink-0 text-etap-deep" aria-hidden="true" />
              {p}
            </li>
          ))}
        </ul>
        <div className="mt-8 flex flex-wrap gap-3">
          <Cta to="/agencies" variant="deep" location={`${location}-agency`} withArrow testId="dual-agency-cta">
            Book a Walkthrough
          </Cta>
          <Cta to="/agencies" variant="ghost" location={`${location}-agency-learn`} testId="dual-agency-learn">
            Learn more
          </Cta>
        </div>
      </Reveal>
    </div>
  );
}
